import { Show, useContext } from 'solid-js';
import { ImageWordpress } from '../../../types/shared';
import { LinkWithIntro } from '../product-types';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { getImageServiceSrcPath } from '../../image-component/image-component';
import removeAmpersand from '../../../tools/remove-ampersand';

type ProductFamilyProps = {
    productFamilyImage: ImageWordpress;
    productFamilyLink: LinkWithIntro;
    productLearnMoreLink: LinkWithIntro;
};

export const ProductFamily = (props: ProductFamilyProps) => {
    const { imagesServiceUrl, supportedImageFormats } = useContext(AppContext);

    const showBlock = () =>
        Boolean(props.productFamilyImage?.url
            || props.productFamilyLink?.link?.url
            || props.productLearnMoreLink?.link?.url);

    return (
        <Show when={showBlock()}>
            <div class="py-cvi-section-close">
                <div class="bg-cvi-bg-block-accent rounded-cvi-md px-cvi-8 py-cvi-9">
                    <div class="flex flex-col tablet-original:grid tablet-original:grid-cols-2 gap-cvi-8 items-start">
                        <div class="min-w-0 flex flex-col gap-cvi-7">
                            <Show when={props.productFamilyLink?.link?.url}>
                                <p class="body-md text-cvi-fg-default m-0">
                                    {props.productFamilyLink.preText}{' '}
                                    <a
                                        href={props.productFamilyLink.link.url}
                                        {...(props.productFamilyLink.link.target === '_blank'
                                            ? { target: '_blank', rel: 'noopener noreferrer' }
                                            : {})}
                                        class="text-cvi-fg-link no-underline hover:underline"
                                    >
                                        {removeAmpersand(props.productFamilyLink.link.title)}
                                    </a>
                                </p>
                            </Show>
                            <Show when={props.productLearnMoreLink?.link?.url}>
                                <p class="body-md text-cvi-fg-default m-0">
                                    {props.productLearnMoreLink.preText}{' '}
                                    <a
                                        href={props.productLearnMoreLink.link.url}
                                        {...(props.productLearnMoreLink.link.target === '_blank'
                                            ? { target: '_blank', rel: 'noopener noreferrer' }
                                            : {})}
                                        class="text-cvi-fg-link no-underline hover:underline"
                                    >
                                        {removeAmpersand(props.productLearnMoreLink.link.title)}
                                    </a>
                                </p>
                            </Show>
                        </div>
                        <Show when={props.productFamilyImage?.url}>
                            <img
                                src={getImageServiceSrcPath({
                                    imagesServiceUrl,
                                    supportedImageFormats,
                                    src: props.productFamilyImage.url,
                                    sign: props.productFamilyImage.sign,
                                    width: 750,
                                    height: 'AUTO',
                                })}
                                alt={props.productFamilyImage.alt || ''}
                                title={props.productFamilyImage.name || ''}
                                class="w-full aspect-[376/225] rounded-cvi-md object-contain"
                            />
                        </Show>
                    </div>
                </div>
            </div>
        </Show>
    );
};
